<app-main-content content>
    <div main fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" *ngIf="externalApp && callbackUrl">
        <a mat-icon-button [href]="callbackUrl">
            <mat-icon>arrow_back</mat-icon>
        </a>
        <a class="back-to-external-app" [href]="callbackUrl">
            {{ 'SUMMARY.EXTERNAL_APP.CALLBACK_URL' | translate }}
        </a>
    </div>
    <div main fxLayout="row" fxLayoutGap="10px" *ngIf="!callbackUrl">
        <button mat-icon-button (click)="navigateBackToConfiguration()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <app-breadcrumbs
            formerPage="{{ 'COMMON.BREADCRUMBS.CONFIGURATION' | translate }}"
            currentPage="{{ 'COMMON.BREADCRUMBS.SUMMARY' | translate }}"
            [navigateTo]="'/configuration'"
            [queryParams]="navigationParams.queryParams"
        ></app-breadcrumbs>
    </div>

    <div class="top-container" fxLayout="row" main fxLayoutAlign="space-between center">
        <h2 class="header-title">{{ 'SUMMARY.TITLE' | translate }}</h2>
        <app-customer-selection
            [showClearButton]="externalApp"
            class="customer-selection-container"
            *ngIf="permissionService.isUserAnEmployee && !isLoading"
        ></app-customer-selection>
    </div>

    <div *ngIf="!isLoading" main fxLayout="column" fxLayoutGap="10px" class="main-container">
        <app-product-table [dataSource]="dataSource" [isExternalApp]="externalApp"></app-product-table>
        <app-scheme-preview *ngIf="primaryScheme" [primaryScheme]="primaryScheme"></app-scheme-preview>
        <app-price-summary
            fxFlex
            [dataSource]="dataSource"
            [isSummaryPage]="true"
            (voucherCodeChanged)="updateVoucherCode($event)"
            [isExternalApp]="externalApp"
        ></app-price-summary>
    </div>
    <app-card main *ngIf="!isLoading && availablePrintTypes?.length" [isHeader]="false" [isFooter]="false">
        <div body fxLayout="row" fxLayoutAlign="space-between center">
            <div fxFlex="50">
                <mat-label id="printType">
                    {{ 'SUMMARY.PRINT_TYPE.LABEL' | translate }}
                    <vi-quest-hint
                        [model]="{ text: 'SUMMARY.PRINT_TYPE.HINT' | translate, important: false }"
                    ></vi-quest-hint>
                </mat-label>
                <mat-radio-group
                    aria-labelledby="printType"
                    [(ngModel)]="printType"
                    fxLayoutAlign="space-between center"
                >
                    <mat-radio-button *ngFor="let type of availablePrintTypes" [value]="type">
                        {{ 'SUMMARY.PRINT_TYPE.TYPES.' + type | translate }}</mat-radio-button
                    >
                </mat-radio-group>
            </div>
            <button
                mat-raised-button
                color="primary"
                [disabled]="
                    (priceSummaryIsLoading() | async)?.value ||
                    (priceSummaryHasErrors() | async)?.value ||
                    !selectedCustomerId
                "
                (click)="closeOffer()"
            >
                <mat-icon>save</mat-icon>
                {{ 'SUMMARY.BUTTON.COMPLETE_CONFIGURATION' | translate }}
            </button>
        </div>
    </app-card>

    <div *ngIf="!isLoading && !externalApp" main fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <button mat-button (click)="navigateBackToConfiguration()">
            <mat-icon>arrow_back</mat-icon>
            {{ 'SUMMARY.BUTTON.BACK_TO_CONFIGURATION' | translate }}
        </button>
        <span class="hint" [innerHTML]="'SUMMARY.HINT.COMPLETE_CONFIGURATION' | translate"></span>
    </div>
    <app-loader main *ngIf="isLoading" [message]="'SUMMARY.LOADER.FINALIZE_OFFER' | translate"></app-loader>
</app-main-content>
